<template>
    <div class="col-xl-3 xl-30 box-col-30">
        <div class="md-sidebar email-sidebar"><a class="btn btn-primary md-sidebar-toggle" href="javascript:void(0)"
                @click="collapseFilter()">bookmark filter</a>
            <div class="md-sidebar-aside job-left-aside custom-scrollbar" :class="filtered ? 'open' : ''">
                <div class="card">
                    <div class="card-body">
                        <div class="email-app-sidebar left-bookmark">
                            <div class="d-flex">
                                <div class="d-flex-size-email"><img class="me-3 rounded-circle"
                                        src="@/assets/images/user/user.png" alt=""></div>
                                <div class="flex-grow-1"><a><router-link to="/users/profile">
                                            <h6 class="f-w-600">MARK JENCO</h6>
                                        </router-link> </a>
                                    <p>Markjecno@gmail.com</p>
                                </div>
                            </div>
                            <ul class="nav main-menu" role="tablist">
                                <newBookmark />
                                <li class="nav-item"><span class="main-title"> Views</span></li>
                                <li><a id="pills-created-tab" data-bs-toggle="pill" href="javascript:void(0)" role="tab"
                                        aria-controls="pills-created" aria-selected="true"><span class="title"
                                            v-on:click="say('pills_created')"> Created by me</span></a></li>
                                <li><a class="show" id="pills-favourites-tab" data-bs-toggle="pill"
                                        href="javascript:void(0)" role="tab" aria-controls="pills-favourites"
                                        aria-selected="false"><span class="title" v-on:click="say('pills_favourites')">
                                            Favourites ({{ favourite.length }})</span></a></li>
                                <li><a class="show" id="pills-shared-tab" data-bs-toggle="pill" href="javascript:void(0)"
                                        role="tab" aria-controls="pills-shared" aria-selected="false"><span class="title"
                                            v-on:click="say('pills_shared')"> Shared with me</span></a></li>
                                <li><a class="show" id="pills-bookmark-tab" data-bs-toggle="pill" href="javascript:void(0)"
                                        role="tab" aria-controls="pills-bookmark" aria-selected="false"><span class="title"
                                            v-on:click="say('pills_bookmark')"> My bookmark</span></a></li>
                                <li>
                                    <hr />
                                </li>
                                <li><span class="main-title"> Tags<span class="pull-right">
                                            <tagsmodal />
                                        </span></span></li>
                                <li><a class="show" id="pills-notification-tab" data-bs-toggle="pill"
                                        href="javascript:void(0)" role="tab" aria-controls="pills-notification"
                                        aria-selected="false"><span class="title" @click="say('pills_notification')">
                                            notification</span></a></li>
                                <li><a class="show" id="pills-newsletter-tab" data-bs-toggle="pill"
                                        href="javascript:void(0)" role="tab" aria-controls="pills-newsletter"
                                        aria-selected="false"><span class="title" @click="say('pills_newsletter')">
                                            Newsletter</span></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-9 col-md-12 box-col-8 xl-70 box-col-70">
        <div class="email-right-aside bookmark-tabcontent">
            <div class="card email-body radius-left">
                <div class="ps-0">
                    <div class="tab-content">
                        <createdbyMe />
                        <favouritePage />
                        <shared />
                        <myBookmark />
                        <notification />
                        <newsletter />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import notification from "./notiFication.vue"
import newsletter from './newsPage.vue'
import shared from "./shareD.vue"
import newBookmark from "./newBookmark.vue"
import tagsmodal from "./tagsModal.vue"
import createdbyMe from "./createdbyMe.vue"
import favouritePage from './favouritePage.vue'
import myBookmark from './myBookmark.vue'
export default {
    components: {
        notification, newsletter, shared, newBookmark, tagsmodal, createdbyMe, favouritePage, myBookmark
    },
    data() {
        return {
            liststyle: false, favourite: this.$store.state.common.favourite, filtered: false,
        };
    },
    methods: {
        getImgUrl(path) {
            return require('@/assets/images/' + path);
        },
        say: function (message) {
            this.$store.dispatch('common/active', message);
        },
        collapseFilter() {
            this.filtered = !this.filtered;
        }
    },
}
</script>